import { render, staticRenderFns } from "./searchWatp.vue?vue&type=template&id=5c2222a6&scoped=true"
import script from "./searchWatp.vue?vue&type=script&lang=js"
export * from "./searchWatp.vue?vue&type=script&lang=js"
import style0 from "./searchWatp.vue?vue&type=style&index=0&id=5c2222a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2222a6",
  null
  
)

export default component.exports